import React from 'react'
import { useWeb3React } from '@web3-react/core'
import {
  Button,
  Flex,
  LogoutIcon,
  useModal,
  UserMenu as UIKitUserMenu,
  UserMenuDivider,
  Text,
} from '@pancakeswap/uikit'
import styled from 'styled-components'
import useAuth from 'hooks/useAuth'
import { useProfile } from 'state/profile/hooks'
import ConnectWalletButton from 'components/ConnectWalletButton'
import { FetchStatus, useGetBnbBalance, useMaster1 } from 'hooks/useTokenBalance'
import { useTranslation } from 'contexts/Localization'
import WalletModal, { WalletView, LOW_BNB_BALANCE } from './WalletModal'
import WalletModal2, { WalletView2, LOW_BNB_BALANCE2 } from './WalletModal2'
import ProfileUserMenuItem from './ProfileUserMenutItem'
import WalletUserMenuItem from './WalletUserMenuItem'

const ButtonText = styled(Text)`
  display: none;
  ${({ theme }) => theme.mediaQueries.xs} {
    display: block;
  }
`

const Nem = () => {
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const { logout } = useAuth()
  const { balance, fetchStatus } = useGetBnbBalance()
  const { isInitialized, isLoading, profile } = useProfile()
  const [onPresentWalletModal] = useModal(<WalletModal2 initialView={WalletView2.WALLET_INFO} />)
  const [onPresentHarvestModal] = useModal(<WalletModal initialView={WalletView.HARVEST} />)
  const [onPresentTransactionModal] = useModal(<WalletModal2 initialView={WalletView2.TRANSACTIONS} />)
  const hasProfile = isInitialized && !!profile
  const avatarSrc = profile && profile.nft ? `/images/nfts/${profile.nft.images.sm}` : undefined
  const hasLowBnbBalance = fetchStatus === FetchStatus.SUCCESS && balance.lte(LOW_BNB_BALANCE)

  if (!account) {
    return  <img src="/images/wallet/2.png" alt="router"  height="0px" width="0px" />
  }

  return (
     <Button
     width={90}  height={32}
  variant='secondary'
  onClick={onPresentTransactionModal}
  mr="10px"
>
   <ButtonText color="text" bold fontSize="15px">
   {t('Events')}
</ButtonText>
</Button>
      
  )
}

export default Nem
